export default "__VITE_ASSET__zEIvW5iz__"